import React from 'react';
import { X } from 'lucide-react';
import DifficultySelector from './DifficultySelector';
import { playSound } from '../../utils/soundManager';

const DifficultyModal = ({ 
  isOpen, 
  onClose, 
  currentDifficulty, 
  onSelect,
  userAge,
  userProgress 
}) => {
  if (!isOpen) return null;

  const handleSelect = (difficulty) => {
    playSound('success');
    onSelect(difficulty);
    setTimeout(() => onClose(), 300);
  };

  const handleClose = () => {
    playSound('click');
    onClose();
  };

  return (
    <div className="difficulty-modal-overlay" onClick={handleClose}>
      <div 
        className="difficulty-modal-content animate-scaleIn" 
        onClick={(e) => e.stopPropagation()}
      >
        <div className="difficulty-modal-header">
          <h2>Change Difficulty Level</h2>
          <button 
            className="difficulty-modal-close hover-scale"
            onClick={handleClose}
          >
            <X size={24} />
          </button>
        </div>
        
        <div className="difficulty-modal-body">
          <DifficultySelector
            currentDifficulty={currentDifficulty}
            onSelect={handleSelect}
            userAge={userAge}
            userProgress={userProgress}
            showSuggestion={true}
          />
        </div>
      </div>
    </div>
  );
};

export default DifficultyModal;
